export default class LoginRequest{
  public constructor(
    public email: string,
    public password: string,
    public deviceId: string
  ){}
}
